/* Open Field v1.1 · site behaviour
   Mega menu (hover + click + Escape), mobile menu, card filters, monthly/yearly price toggle. */
(function () {
  "use strict";
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var root = document.documentElement;

  /* nav height for the mega panel */
  var nav = $(".of-nav");
  function navh() { if (nav) root.style.setProperty("--of-navh", nav.getBoundingClientRect().height + "px"); }
  navh(); window.addEventListener("resize", navh); window.addEventListener("scroll", navh, { passive: true });

  /* mega menu */
  $$(".of-dd").forEach(function (dd) {
    var btn = $("button", dd), t = 0;
    function set(on) { dd.classList.toggle("is-open", on); btn.setAttribute("aria-expanded", on ? "true" : "false"); }
    btn.addEventListener("click", function () { set(!dd.classList.contains("is-open")); });
    if (window.matchMedia("(hover: hover)").matches) {
      dd.addEventListener("mouseenter", function () { clearTimeout(t); set(true); });
      dd.addEventListener("mouseleave", function () { t = setTimeout(function () { set(false); }, 180); });
    }
    document.addEventListener("keydown", function (e) { if (e.key === "Escape") { set(false); } });
    document.addEventListener("click", function (e) { if (!dd.contains(e.target)) set(false); });
  });

  /* mobile menu */
  var burger = $(".of-burger");
  if (burger) {
    burger.addEventListener("click", function () {
      var on = !root.classList.contains("of-menu-open");
      root.classList.toggle("of-menu-open", on);
      burger.setAttribute("aria-expanded", on ? "true" : "false");
      document.body.style.overflow = on ? "hidden" : "";
    });
    $$(".of-mob a").forEach(function (a) { a.addEventListener("click", function () { root.classList.remove("of-menu-open"); document.body.style.overflow = ""; }); });
  }

  /* card filters: <div data-filter="plans"> buttons [data-f="goal"][data-v="fat"]; cards [data-goal="fat stress"] */
  $$("[data-filter]").forEach(function (box) {
    var scope = $(box.getAttribute("data-filter")), cards = scope ? $$("[data-card]", scope) : [], sel = {};
    var count = $("[data-count]", box);
    function apply() {
      var n = 0;
      cards.forEach(function (c) {
        var ok = Object.keys(sel).every(function (k) { return !sel[k] || (" " + (c.getAttribute("data-" + k) || "") + " ").indexOf(" " + sel[k] + " ") >= 0; });
        c.hidden = !ok; if (ok) n++;
      });
      if (count) count.innerHTML = "<b>" + n + "</b> of " + cards.length;
    }
    box.addEventListener("click", function (e) {
      var b = e.target.closest("[data-f]"); if (!b) return;
      var k = b.getAttribute("data-f"), v = b.getAttribute("data-v");
      $$('[data-f="' + k + '"]', box).forEach(function (x) { x.setAttribute("aria-pressed", x === b ? "true" : "false"); });
      sel[k] = v === "all" ? "" : v; apply();
    });
    apply();
  });

  /* price toggle: [data-billing] switch swaps [data-pm] for [data-py] text in its section */
  $$("[data-billing]").forEach(function (sw) {
    var scope = sw.closest("section") || document;
    function set(y) {
      sw.setAttribute("aria-checked", y ? "true" : "false");
      $$("[data-pm]", scope).forEach(function (el) { el.textContent = y ? el.getAttribute("data-py") : el.getAttribute("data-pm"); });
      $$("[data-per]", scope).forEach(function (el) { el.textContent = y ? el.getAttribute("data-per-y") : el.getAttribute("data-per"); });
    }
    sw.addEventListener("click", function () { set(sw.getAttribute("aria-checked") !== "true"); });
  });
})();
